// (function () {
//     'use strict';
//
//     angular
//         .module('estadisticas')
//         .factory('FiltrosCache', FiltrosCacheService);

    FiltrosCacheService.$inject = ['$http', '$q'];
    export default function FiltrosCacheService($http, $q) {
        var self = this;
        self.datos = {};

        function _getTecnicos() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.tecnicos !== 'undefined') {
                defered.resolve(self.datos.tecnicos);
            } else {
                $http.get(Sigo.url + '/estadisticas/graficos/tecnicos').then(function (data) {
                    self.datos.tecnicos = data.data;
                    defered.resolve(self.datos.tecnicos);
                });
            }
            return promesa;
        }

        function _getReparadores() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.reparadores !== 'undefined') {
                defered.resolve(self.datos.reparadores);
            } else {
                $http.get(Sigo.url + '/estadisticas/graficos/reparadores').then(function (data) {
                    self.datos.reparadores = data.data;
                    defered.resolve(self.datos.reparadores);
                });
            }
            return promesa;
        }

        function _getEntidadEstudio() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.entidadesEstudio !== 'undefined') {
                defered.resolve(self.datos.entidadesEstudio);
            } else {
                $http.get(Sigo.url + '/estadisticas/graficos/entidades-estudio').then(function (data) {
                    self.datos.entidadesEstudio = data.data;
                    defered.resolve(self.datos.entidadesEstudio);
                });
            }
            return promesa;
        }

        function _getEntidadReparadora() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.entidadesReparadoras !== 'undefined') {
                defered.resolve(self.datos.entidadesReparadoras);
            } else {
                $http.get(Sigo.url + '/estadisticas/graficos/entidades-reparadoras').then(function (data) {
                    self.datos.entidadesReparadoras = data.data;
                    defered.resolve(self.datos.entidadesReparadoras);
                });
            }
            return promesa;
        }

        function _getOrigenes() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.origenes !== 'undefined') {
                defered.resolve(self.datos.origenes);
            } else {
                $http.get(Sigo.url + '/estadisticas/graficos/origenes').then(function (data) {
                    self.datos.origenes = data.data;
                    defered.resolve(self.datos.origenes);
                });
            }
            return promesa;
        }

        function _getDistritos() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.distritos !== 'undefined') {
                defered.resolve(self.datos.distritos);
            } else {
                $http.get(Sigo.url + '/estadisticas/graficos/distritos').then(function (data) {
                    self.datos.distritos = data.data;
                    defered.resolve(self.datos.distritos);
                });
            }
            return promesa;
        }

        function _getUnidadesGestion() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.unidadesGestion !== 'undefined') {
                defered.resolve(self.datos.unidadesGestion);
            } else {
                $http.get(Sigo.url + '/estadisticas/graficos/unidades-gestion').then(function (data) {
                    self.datos.unidadesGestion = data.data;
                    defered.resolve(self.datos.unidadesGestion);
                });
            }
            return promesa;
        }

        function _getTipos() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.tipos !== 'undefined') {
                defered.resolve(self.datos.tipos);
            } else {
                $http.get(Sigo.url + '/estadisticas/graficos/tipos').then(function (data) {
                    self.datos.tipos = data.data;
                    defered.resolve(self.datos.tipos);
                });
            }
            return promesa;
        }

        function _getEstadosEstudio() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.estadosEstudio !== 'undefined') {
                defered.resolve(self.datos.estadosEstudio);
            } else {
                $http.get(Sigo.url + '/api/v1/estados/estudio').then(function (data) {
                    self.datos.estadosEstudio = data.data.estudio;
                    defered.resolve(self.datos.estadosEstudio);
                });
            }
            return promesa;
        }

        function _getEstadosReparacion() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.estadosReparacion !== 'undefined') {
                defered.resolve(self.datos.estadosReparacion);
            } else {
                $http.get(Sigo.url + '/api/v1/estados/reparacion').then(function (data) {
                    self.datos.estadosReparacion = data.data.reparacion;
                    defered.resolve(self.datos.estadosReparacion);
                });
            }
            return promesa;
        }

        function _getEstadosIncidencia() {
            var defered = $q.defer();
            var promesa = defered.promise;
            if (typeof self.datos.estadosIncidencia !== 'undefined') {
                defered.resolve(self.datos.estadosIncidencia);
            } else {
                $http.get(Sigo.url + '/api/v1/estados/incidencia').then(function (data) {
                    self.datos.estadosIncidencia = data.data.incidencia;
                    defered.resolve(self.datos.estadosIncidencia);
                });
            }
            return promesa;
        }

        return {
            getTecnicos: _getTecnicos,
            getReparadores: _getReparadores,
            getEntidadEstudio: _getEntidadEstudio,
            getEntidadReparadora: _getEntidadReparadora,
            getOrigenes: _getOrigenes,
            getDistritos: _getDistritos,
            getUnidadesGestion: _getUnidadesGestion,
            getTipos: _getTipos,
            getEstadosEstudio: _getEstadosEstudio,
            getEstadosReparacion: _getEstadosReparacion,
            getEstadosIncidencia: _getEstadosIncidencia
        };
    }

// })();